// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchUpsell-cls1_-C7","cls2":"SearchUpsell-cls2_vTz SearchUpsell-cls1_-C7"};